import { useEffect, useRef } from 'react';

interface PreloaderProps {
  size?: 'small' | 'medium' | 'large';
  text?: string;
  fullScreen?: boolean;
}

export function Preloader({
  size = 'medium',
  fullScreen = false
}: PreloaderProps) {
  const preloaderRef = useRef<HTMLDivElement>(null);
  
  useEffect(() => {
    const host = preloaderRef.current;
    if (!host) return;
    
    const bars: HTMLElement[] = [];
    
    // Create bars
    for (let i = 0; i < 3; i++) {
      const bar = document.createElement('div');
      bar.className = 'preloader-bar';
      bars.push(bar);
      host.appendChild(bar);
    }
    
    // Set initial class
    host.className = `preloader-host ${size} animate`;
    
    // Animation sequence
    setTimeout(() => {
      host.className = `preloader-host ${size} start animate`;
    }, 300);
    
    setTimeout(() => {
      host.className = `preloader-host ${size} start complete`;
    }, 1100);
    
    setTimeout(() => {
      // Bar animation
      const barAnimation = (index: number) => {
        setTimeout(() => {
          setInterval(() => {
            const isActive = bars[index].classList.contains('active');
            if (isActive) {
              bars[index].classList.remove('active');
            } else {
              bars[index].classList.add('active');
            }
          }, 700);
        }, (index === 0) ? 50 : index * 150 + 50);
      };
      
      // Start bar animations
      for (let b = 0; b < bars.length; b++) {
        barAnimation(b);
      }
    }, 1100);
    
    // Cleanup
    return () => {
      bars.forEach(bar => {
        if (host.contains(bar)) {
          host.removeChild(bar);
        }
      });
    };
  }, [size]);
  
  return (
    <div className={`preloader-container ${fullScreen ? 'full-screen' : ''}`}>
      <div ref={preloaderRef} className={`preloader-host ${size}`}></div>
    </div>
  );
}
